module.exports = __webpack_public_path__ + "static/media/Challenger350.8de23ef7.png";